import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerPhotosDetailsComponent } from './customer-photos-details.component';

const routes: Routes = [{ path: '', component: CustomerPhotosDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerPhotosDetailsRoutingModule {}

@NgModule({
  imports: [
    CustomerPhotosDetailsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [CustomerPhotosDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerPhotosDetailsModule {}
